// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContractCard_wrapper__8HfIO","legend":"ContractCard_legend__7r0Iq","item":"ContractCard_item__g3XDH"};